@if (tabs.length > 0) {
  <div class="tabs">
    <!-- Render tabs from the tabs array -->

    @for (tab of tabs; let i = $index; track tab.label + i) {
      <button #tabButton (click)="selectTab(i)" [class.active]="i === activeTabIndex" [class.disabled]="disabled" [disabled]="disabled">
        {{ tab.displayName || tab.label }}
        @if (tab.count) {
          @if (tab.count) {
            <app-badge [backgroundColor]="i !== activeTabIndex ? 'var(--gray-150)' : ''" [color]="i !== activeTabIndex ? 'var(--gray-500)' : ''" [text]="tab.count.toString()"></app-badge>
          }
        }
      </button>
    }

    <!-- Sliding indicator -->
    <span [ngStyle]="{ left: indicatorLeft + 'px', width: indicatorWidth + 'px' }" class="tab-indicator"></span>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="templateTabs"></ng-container>
}

<!-- Template outlet for rendering active tab content -->
@if (tabs.length > 0) {
  <ng-container [ngTemplateOutlet]="selectedTemplate?.template"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="contentTabs"></ng-container>
}

<ng-template #templateTabs>
  <div class="tabs">
    @for (template of templates; let i = $index; track template.tabName + i) {
      <button #tabButton (click)="selectTab(i)" [class.active]="i === activeTabIndex" [class.disabled]="disabled" [disabled]="disabled" [ngStyle]="template.dynamicTabButtonCssStyle">
        @if (template.count) {
          <app-badge [backgroundColor]="i !== activeTabIndex ? 'var(--gray-150)' : ''" [color]="i !== activeTabIndex ? 'var(--gray-500)' : ''" [text]="template.count.toString()"></app-badge>
        }
        {{ template.tabName }}
      </button>
    }
    <!-- Sliding indicator -->
    <span [ngStyle]="{ left: indicatorLeft + 'px', width: indicatorWidth + 'px' }" class="tab-indicator"></span>
  </div>
</ng-template>

<!-- Fallback content rendering when using template-based tabs -->
<ng-template #contentTabs>
  <ng-container [ngTemplateOutlet]="selectedTemplate?.template"></ng-container>
</ng-template>
